import { PiPushPin, PiPushPinFill } from 'react-icons/pi'
import { toast } from 'react-toastify'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { FloatingTooltip } from '../Tooltip/FloatingTooltip'
import { cn } from '../UI/cn'
import { usePinTarget, type PinTarget } from './usePinTarget'

type PinToHomepageButtonProps = { target: PinTarget; className?: string }

// Top-right toggle for pinning a target (page or entity) to the homepage
// Quick Access card. Outline pin = not pinned, filled pin = pinned. Styled
// like the small header icon buttons (three-dot / close) used elsewhere.
export function PinToHomepageButton({
  target,
  className,
}: PinToHomepageButtonProps) {
  const { enableQuickAccess } = useFeatureFlagService()
  const { isPinned, toggle, isPending } = usePinTarget(target)

  if (!enableQuickAccess) return null

  const Icon = isPinned ? PiPushPinFill : PiPushPin
  const label = isPinned ? 'Unpin from homepage' : 'Pin to homepage'
  return (
    <FloatingTooltip text={label} theme="dark">
      <button
        type="button"
        disabled={isPending}
        onClick={() => {
          toggle()
          toast.success(
            isPinned ? 'Unpinned from homepage' : 'Pinned to homepage'
          )
        }}
        aria-label={label}
        aria-pressed={isPinned}
        className={cn(
          'flex size-8 shrink-0 items-center justify-center rounded-lg transition-colors disabled:opacity-50',
          isPinned
            ? 'text-brand hover:bg-neutral-100'
            : 'text-neutral-400 hover:bg-neutral-100 hover:text-neutral-500',
          className
        )}
      >
        <Icon size={18} />
      </button>
    </FloatingTooltip>
  )
}
